import React from "react"

import SimplePage from "layouts/SimplePage"

import LoginForm from "./LoginForm"

export default function Login() {
  return (
    <SimplePage className="Login">
      <h1>Prijava</h1>
      <p>
        Prijava v portal Avtolog je brezplačna in vam bo omogočila dostop do
        razširjene funkcionalnosti portala. Vaših podatkov ne bomo delili s
        tretjimi osebami.
      </p>
      <LoginForm />
    </SimplePage>
  )
}
